import { useEffect, useState } from 'react';
import axiosConn from '../../axiosConn';

// Fail closed for optional sharing. Written feedback remains useful when off.
export default function useHitLabResultSharingCapability() {
  const [capability, setCapability] = useState({
    sharingAvailable: false,
    exampleFeedback: [],
    exampleError: false,
  });
  useEffect(() => {
    let active = true;
    axiosConn
      .get('hitlab/result-sharing')
      .then((response) => {
        if (!active) return;
        const data = response?.data?.data;
        setCapability({
          sharingAvailable: data?.enabled === true,
          exampleFeedback: Array.isArray(data?.exampleFeedback)
            ? data.exampleFeedback.filter((line) => typeof line === 'string')
            : [],
          exampleError: false,
        });
      })
      .catch(() => {
        if (active)
          setCapability({
            sharingAvailable: false,
            exampleFeedback: [],
            exampleError: true,
          });
      });
    return () => {
      active = false;
    };
  }, []);
  return capability;
}
